module.exports = __webpack_public_path__ + "static/media/news-morgan.1ff626d3.jpg";